<div [ngClass]="{ 'dark-mode': false }" class="auth-container">
  <div class="container-text-login">
    <div class="auth-box" style="position: relative">
      <img
        src="/assets/icons/arrow_right.svg"
        alt="arrow"
        width="20px"
        height="20px"
        style="position: absolute; left: 20px; top: 20px; cursor: pointer; transform: rotate(180deg)"
        (click)="gotoLogin()"
      />
      <div class="auth-box-logo">
        <svg width="200" height="150" viewBox="0 0 887 446" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M886.37 385.026H829.832V441.585H886.37V385.026Z" fill="white" />
          <path
            d="M715.088 133.19L748.767 385.985L782.404 133.19H834.888L785.802 441.585H711.179L662.615 133.19H715.088Z"
            fill="white"
          />
          <path
            d="M29.636 133.19H0.543274V174.176H29.636V441.585H80.7849V174.176H116.716V133.19H80.7849V70.5017C80.7849 61.3601 82.682 54.3556 87.0913 49.5815C91.5213 44.8179 98.3177 42.5664 107.491 42.5664H116.705V0.621429H98.2031C75.469 0.621429 53.5792 5.4266 43.1555 15.3187C32.7526 25.2004 29.636 40.5544 29.636 62.4442V133.19Z"
            fill="white"
          />
          <path d="M132.684 441.585H183.959V133.19H132.684V441.585Z" fill="white" />
          <path
            d="M420.691 304.847H527.576V209.804C527.44 152.943 500.099 129.636 448.325 129.636C394.455 129.636 369.219 152.891 369.219 210.169V366.358C369.365 418.476 400.928 445.421 448.293 445.421C495.659 445.421 527.441 423.24 527.576 366.358V341.664H478.053L478.111 370.934C478.111 391.802 470.294 406.249 449.321 406.249C428.338 406.249 420.687 391.677 420.687 370.902L420.691 304.847ZM420.691 199.568C420.691 182.171 425.215 164.159 449.179 164.159C473.144 164.159 478.011 181.91 478.011 199.547V263.288H420.691V199.568Z"
            fill="white"
          />
          <path
            d="M299.245 266.259C260.354 232.476 257.321 227.597 257.321 202.434C257.321 180.983 259.187 167.932 278.45 167.932C297.692 167.932 300.214 180.826 300.214 202.674V231.141H349.623V184.693C349.466 148.221 321.395 129.667 277.313 129.667C233.961 129.667 205.671 144.103 205.431 202.434C205.398 212.337 205.44 212.337 205.431 208.512C205.515 226.847 205.598 255.898 250.921 294.789L263.909 305.911C297.296 334.075 300.965 337.473 300.798 370.965C300.781 391.604 299.516 407.25 277.845 407.25C256.174 407.25 254.819 391.489 254.819 381.753V342.3H202.951V383.015C202.951 433.111 235.546 445.505 277.783 445.505C320.051 445.505 352.708 432.996 352.708 368.526V363.168C352.593 318.137 344.442 306.056 299.245 266.259Z"
            fill="white"
          />
          <path
            d="M596.195 164.94V133.19H549.476V441.575H599.885V226.659C599.852 210.044 605.274 199.109 614.697 192.647C623.62 186.497 634.607 184.412 648.564 184.214V129.656C621.817 130.198 610.288 135.483 596.716 163.815L596.195 164.94Z"
            fill="white"
          />
        </svg>
      </div>
      <div class="d-flex justify-content-center fiserv55" style="display: flex; justify-content: center">
        <span class="title-box" style="display: flex; justify-content: center">Restaurar contraseña</span>
      </div>
      <form [formGroup]="recoveryForm" class="auth-form" (ngSubmit)="onSubmit($event)">
        <mat-form-field class="input-fiserv fiserv45-lt" appearance="outline">
          <mat-label class="input-fiserv">Código recibido en email</mat-label>
          <input
            matInput
            type="text"
            maxlength="6"
            pattern="[0-9]*"
            placeholder="Código de 6 dígitos"
            formControlName="code"
            required
            autocomplete="off"
          />
          <mat-error *ngIf="recoveryForm.controls.code.invalid && recoveryForm.controls.code.dirty">
            El código debe ser de 6 dígitos numéricos
          </mat-error>
        </mat-form-field>

        <mat-form-field class="input-fiserv fiserv45-lt" appearance="outline">
          <mat-label class="input-fiserv">Nueva contraseña</mat-label>
          <span cdkOverlayOrigin #passwordOrigin="cdkOverlayOrigin">
            <input
              matInput
              id="passwordInput"
              type="{{ passwordType }}"
              placeholder="Nueva contraseña"
              formControlName="password"
              required
              autocomplete="off"
              style="position: relative; z-index: 2"
              (focus)="showPasswordPanel = true"
              (input)="showPasswordPanel = true"
              (blur)="showPasswordPanel = false"
            />
          </span>
          <mat-icon matSuffix *ngIf="passwordType === 'password'" (click)="togglePassword()" style="cursor: pointer">
            visibility
          </mat-icon>

          <mat-icon matSuffix *ngIf="passwordType === 'text'" (click)="togglePassword()" class="clickeable">
            visibility_off
          </mat-icon>

          <ng-template
            cdkConnectedOverlay
            [cdkConnectedOverlayOrigin]="passwordOrigin"
            [cdkConnectedOverlayOpen]="showPasswordPanel"
            [cdkConnectedOverlayPositions]="overlayPositions"
            [cdkConnectedOverlayScrollStrategy]="scrollStrategy"
            [cdkConnectedOverlayHasBackdrop]="false"
          >
            <div
              class="password-req-panel flat-overlay minimal-container"
              style="
                margin-top: 40px;
                border-radius: 6px;
                box-shadow: none;
                background: #f7f7fa;
                padding: 12px 16px;
                border: 1px solid #e0e0e0;
              "
            >
              <div class="password-tooltip-content flat-tooltip">
                <div class="popover-title" style="font-weight: 600; font-size: 14px; margin-bottom: 4px">
                  Requisitos de la contraseña:
                </div>
                <div
                  class="popover-item"
                  [ngClass]="getReqClass(passwordReqs.length)"
                  style="background: none; box-shadow: none; border-radius: 0; padding: 2px 0"
                >
                  <mat-icon [ngStyle]="{ color: getReqColor(passwordReqs.length), 'vertical-align': 'middle' }">{{
                    getReqMenuIcon(passwordReqs.length)
                  }}</mat-icon>
                  <span style="margin-left: 4px">Mínimo 12 caracteres</span>
                </div>
                <div
                  class="popover-item"
                  [ngClass]="getReqClass(passwordReqs.uppercase)"
                  style="background: none; box-shadow: none; border-radius: 0; padding: 2px 0"
                >
                  <mat-icon [ngStyle]="{ color: getReqColor(passwordReqs.uppercase), 'vertical-align': 'middle' }">{{
                    getReqMenuIcon(passwordReqs.uppercase)
                  }}</mat-icon>
                  <span style="margin-left: 4px">Una mayúscula</span>
                </div>
                <div
                  class="popover-item"
                  [ngClass]="getReqClass(passwordReqs.lowercase)"
                  style="background: none; box-shadow: none; border-radius: 0; padding: 2px 0"
                >
                  <mat-icon [ngStyle]="{ color: getReqColor(passwordReqs.lowercase), 'vertical-align': 'middle' }">{{
                    getReqMenuIcon(passwordReqs.lowercase)
                  }}</mat-icon>
                  <span style="margin-left: 4px">Una minúscula</span>
                </div>
                <div
                  class="popover-item"
                  [ngClass]="getReqClass(passwordReqs.number)"
                  style="background: none; box-shadow: none; border-radius: 0; padding: 2px 0"
                >
                  <mat-icon [ngStyle]="{ color: getReqColor(passwordReqs.number), 'vertical-align': 'middle' }">{{
                    getReqMenuIcon(passwordReqs.number)
                  }}</mat-icon>
                  <span style="margin-left: 4px">Un número</span>
                </div>
                <div
                  class="popover-item"
                  [ngClass]="getReqClass(passwordReqs.symbol)"
                  style="background: none; box-shadow: none; border-radius: 0; padding: 2px 0"
                >
                  <mat-icon [ngStyle]="{ color: getReqColor(passwordReqs.symbol), 'vertical-align': 'middle' }">{{
                    getReqMenuIcon(passwordReqs.symbol)
                  }}</mat-icon>
                  <span style="margin-left: 4px">Un símbolo</span>
                </div>
                <div
                  class="popover-item"
                  [ngClass]="getReqClass(passwordReqs.repeated2Consecutive)"
                  style="background: none; box-shadow: none; border-radius: 0; padding: 2px 0"
                >
                  <mat-icon
                    [ngStyle]="{ color: getReqColor(passwordReqs.repeated2Consecutive), 'vertical-align': 'middle' }"
                    >{{ getReqMenuIcon(passwordReqs.repeated2Consecutive) }}</mat-icon
                  >
                  <span style="margin-left: 4px">No más de dos caracteres iguales consecutivamente</span>
                </div>
              </div>
            </div>
          </ng-template>
        </mat-form-field>

        <mat-form-field class="input-fiserv fiserv45-lt" appearance="outline">
          <mat-label class="input-fiserv">Confirmar contraseña</mat-label>
          <input
            matInput
            type="password"
            placeholder="Confirmar contraseña"
            formControlName="confirmPassword"
            required
            autocomplete="off"
            [ngClass]="{
              'input-error':
                recoveryForm.get('confirmPassword')?.hasError('passwordMismatch') &&
                recoveryForm.controls.confirmPassword.touched
            }"
          />
          <mat-hint
            class="error-message"
            *ngIf="
              recoveryForm.get('confirmPassword')?.hasError('passwordMismatch') &&
              recoveryForm.controls.confirmPassword.touched
            "
          >
            Las contraseñas no coinciden.
          </mat-hint>
        </mat-form-field>
        <div class="auth-btn-box">
          <button
            class="auth-btn font-clear"
            mat-raised-button
            type="submit"
            style="cursor: pointer"
            [disabled]="recoveryForm.invalid || loading"
            color="primary"
          >
            <div class="text-btn-login fiserv65-bd nodarkmode" style="color: white">
              <span style="font-size: 16px">Restaurar contraseña</span>
              <ng-container *ngIf="!loading; else spinner">
                <img
                  class="rotate-180"
                  src="/assets/icons/arrow_right.svg"
                  alt="arrow"
                  width="16px"
                  height="16px"
                  style="margin-left: 12px; filter: brightness(0) invert(1)"
                />
              </ng-container>
              <ng-template #spinner>
                <mat-progress-spinner
                  diameter="18"
                  mode="indeterminate"
                  color="accent"
                  style="margin-left: 12px; vertical-align: middle"
                  strokeWidth="3"
                ></mat-progress-spinner>
              </ng-template>
            </div>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
